import { render, staticRenderFns } from "./loginModal.vue?vue&type=template&id=3bf4dd90&scoped=true"
import script from "./loginModal.vue?vue&type=script&lang=js"
export * from "./loginModal.vue?vue&type=script&lang=js"
import style0 from "./loginModal.vue?vue&type=style&index=0&id=3bf4dd90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf4dd90",
  null
  
)

export default component.exports